<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import appConfig from "@/app.config.json";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Loader from "../components/loader.vue";
import api from "@/axios";
import moment from "moment";
import Swal from "sweetalert2";
import {ref} from "vue";
import router from "@/router";
// import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import { DxColumn, DxColumnChooser, DxColumnFixing, DxDataGrid, DxExport, DxFilterRow, DxGrouping, DxGroupPanel,
  DxPager, DxRemoteOperations, DxStateStoring
} from "devextreme-vue/data-grid";
// import DxButton from "devextreme-vue/button";
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from "file-saver-es";
import {getBaseUrl} from "@/helpers/baseUrl";
import PageActionBar from "@/components/page-action-bar.vue";


export default {
  page: {
    title: "Compra",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    DxColumn,  DxGroupPanel, DxStateStoring, DxGrouping, DxColumnFixing, DxFilterRow, DxColumnChooser,
    DxRemoteOperations, DxPager, DxExport, DxDataGrid, Layout, PageHeader, Loader, Multiselect, PageActionBar, },
   // DxToolbar, DxButton, DxItem

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      console.log(arquivo)

    };
    return { dropzoneFile, drop, selectedFile, v$: useVuelidate() };
  },
  data() {
    return {
      userLogged: null,
      exibirTodos: true,
      percTotalSeparado: 0,
      contTotalItens: 0,
      contTotalItensSep: 0,
      contTotalFalta: 0,
      wmsOsItensSeparados: null,
      wmsItesSeparados: 0,
      showModalAnexoList: false,
      showModalAnexo: false,
      submittedAnexo: false,
      descranexo: '',
      mediasAnexoData: null,

      ultSepsData: {},
      wmsOsItemSepData: {},
      wmsOsItemSepDataList: null,
      wmsOsItemSepDataDisp: 0,
      showModalSepara: false,
      showModalSeparaTodos: false,
      showModalSeparaTodos2: false,
      financeiroData: {},
      showModalMediaJson: false,
      mediaJsonCorpem: {},
      showModalXML: false,
      xmlContent: '1,2,3',
      mediasData: {},
      submitMovCompraItem: false,

      loadingFornec: false,
      loadingCondPgto: false,
      loadingFormaPgto: false,
      loadingPedTipo: false,
      loadingMovCompraItem: false,
      loadingWmsEnder: false,


      dtListPesqFor: null,
      dtListPesqCondPgto: null,
      dtListPesqFormaPgto: null,
      dtlistPesqPedTipo: null,
      dtlistPesqMovCompraItem: null,
      dtListPesqWmsEnder: null,
      dtlistPesqPalete: null,
      paleteData: null,
      enderecoData: null,
      dtlistPesqEndereco: null,

      showModalFornecedor: false,
      showModalCondPgto: false,
      showModalFormaPgto: false,
      showModalPedTipo: false,
      showModalMovCompraItem: false,
      showModalObs: false,
      showModalImpXML: false,

      sepTodos: {
        palete: null,
        descricao: 'A.001.1.0',
        tipo: 'padrao',
        compr: 120,
        larg: 100,
        alt: 150,
        posx: 1,
        posy: 1
      },

      wmsOsData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        fornec: '23',
        tipo: '06',
        dtemissao: new Date
      },
      fornecedorData: null,
      condPgtoData: {
        'codigo': '10',
        'descricao': '30 / 60 Dias'
      },
      formaPgtoData: {
        'codigo': '10',
        'descricao': 'Boleto'
      },
      pedTipoData: {
        'codigo': '06',
        'descricao': 'Compra de Mercadoria'
      },
      wmsOsItemData: {},
      wmsOsItensData: {},
      wmsOsItensFaltaData: {},
      wmsEnderData: null,

      somaPedidosFor: 0,
      ultPedsData: null,
      errosValid: null,

      idData: 0,
      updating: true,
      title: "Editar OS Entrada",
      items: [
        {
          text: "Ordens de Serviço",
          href: "/wmsos/list",
        },
        {
          text: "Editar OS Entrada",
          active: true,
        },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      currentPage: 1,
      pesqTextFilter: '',
      totalItens: 0,

      obrigInfoLote: false,
      validacaoLote: false,

      showModalRelatTFA: false,
      dtListRelatTFA: {},
      wmsOsItensAgrup: null,
      movItemSepPendData: {}
    };
  },
  validations: {
    wmsOsItemData: {
      produto: {
        required: helpers.withMessage("Campo produto obrigatório, favor preencher.", required),
      },
      qtd: {
        required: helpers.withMessage("Campo quantidade obrigatório, favor preencher.", required),
      },
      vlrunitliq: {
        required: helpers.withMessage("Campo valor unitário obrigatório, favor preencher.", required),
      },
      vlrtotalliq: {
        required: helpers.withMessage("Campo valor total obrigatório, favor preencher.", required),
      },
    }
  },
  watch: {
    'wmsOsItemData.qtd': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'wmsOsItemData.vlrunitliq': {
      handler() {
        this.calculaTotalItem()
      }
    },
  },

  computed: {
    dataGrid: function () {
      return this.$refs.dataGridRefKey.instance;
    },
  },
  mounted() {

    this.userLogged = JSON.parse(localStorage.getItem('user'))

    console.log('mounted_wmsOs_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0){
      this.carregarDados()
      this.carregarDadosItens()
    }else{
      this.title = `Criando Nova Solicitação de Compra`
      this.updating = false
      let emprAtu = localStorage.getItem('empratu')
      this.wmsOsData.empresa = emprAtu
    }

  },

  methods:{
    abrirRomaneio() {
      console.log('abrirRomaneio')


      this.$router.push(`/wmsromaneio/editar/${this.wmsOsData.wmsroma_id}`)


    },


    pesqPalete(evt) {
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.loadingPedTipo = true
        this.wmsOsItemSepData.palete = ''
        api.get(`${getBaseUrl()}api/palpes`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPalete = res.data
        })
      }
    },

    escolheuPalete() {
      console.log('escolheuPalete')
      // this.loadingCondPgto = true
      console.log(this.wmsOsItemSepData.palete)
      api.get(`${getBaseUrl()}api/palcod`, {
        params: { coddata: this.wmsOsItemSepData.palete }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.paleteData = res.data[0]
      })
    },



    pesqEndereco(evt) {
      console.log('pesqEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.loadingPedTipo = true
        this.wmsOsItemSepData.endwms = ''
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "wmsos", origem_id: this.wmsOsData.id }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqEndereco = res.data
        })
      }
    },

    escolheuEndereco() {
      console.log('escolheuEndereco')
      // this.loadingCondPgto = true
      console.log(this.wmsOsItemSepData.endwms)
      api.get(`${getBaseUrl()}api/endercod`, {
        params: { coddata: this.wmsOsItemSepData.endwms }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.enderecoData = res.data[0]
      })
    },


    cancelar() {
      console.log('cancelarOS')

      console.log('excluirLancto')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/wmsos`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              router.push('/wmsos/list');
            })
          })
        }
      })


    },


    associarSaldo(){
      console.log('associarSaldo')

      api.get(`${getBaseUrl()}api/assocsaldo`, {
        params: { iddata: this.wmsOsData.id }
      }).then((res) => {
        console.log('then axios assoc_saldo')
        console.log(res.data)


        // this.condPgtoData = res.data[0]
        // this.ultPedsData = res.data[1]
        //
        // let totalPed = 0
        // this.ultPedsData.forEach((value) => {
        //   totalPed += value.valorliq
        // });
        //
        // this.somaPedidosCli = totalPed
        // this.loadingCondPgto = false
      })

    },

    /*efetivarSepPend2(){
      console.log('efetivarSepPend')
      this.updatingListas = true
      api.post(`${getBaseUrl()}api/wmsosconfentrsepmuitos`, {
        'movItemSepPendData': this.wmsOsItensSeparados,
        'idwmsos': this.idData
      }).then((res) => {
        console.log('then axios separarPend')
        console.log(res.data)
        // console.log(JSON.stringify(res.data))

        if(!res.data.finalizado){
          console.log('conferência salva')

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.wmsOsItensSeparados = {}
            this.carregarDados()
          })
        }
      })
    },*/

    confSepararTodos(){
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Separar Todos Itens",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          // console.log(result.value)
          // console.log('vai')
          this.wmsOsItemData['idwmsos'] = this.idData
          this.updatingListas = true
          this.updating = true
          this.selectedFinalizado = true
          this.showModalMsgUpdating = true
          api.post(`${getBaseUrl()}api/wmsossepentrtodos`, {
            'movItemSepPendData': this.movItemSepPendData,
            'iddata': this.idData
          }).then((res) => {
            this.selectedFinalizado = false
            this.showModalMsgUpdating = false

            this.updatingListas = false
            this.updating = false
            console.log('then axios separar todos coletor')
            console.log(res.data)

            if (res.data.success === true) {
              Swal.fire({
                icon: 'success',
                position: 'center',
                showCancelButton: false,
                showConfirmButton: false,
                title: res.data.message,
                timer: 2500
              })
              this.atualizaPagina()
            } else {
              Swal.fire({
                icon: 'error',
                position: 'top-end',
                showCancelButton: false,
                showConfirmButton: false,
                text: res.data.message,
                timer: 3000
              }).then(() => {

                if(res.data.relatTFA){
                  this.dtListRelatTFA = res.data.relatTFA
                  this.showModalRelatTFA = true
                }
              })
            }
            this.showListConfig = false
          }).catch((e) => {
            console.log('error...')
            console.log(e)
          })
        }
      })
    },

    confFinalizarParcialColetor(){
      console.log('conffinalizarParcial...')

      Swal.fire({
        position: "center",
        icon: 'info',
        title: 'Deseja Confirmar Finalização?',
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sim",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((value) => {
        console.log(value)
          if(value.isConfirmed){
            Swal.fire({
              position: "center",
              icon: 'info',
              title: 'Escolha o estoque de destino dos itens faltantes da conferência!',
              denyButtonText: "Avaria",
              confirmButtonText: "Falta",
              denyButtonColor: "#f6ae35",
              confirmButtonColor: "#ed4f4f",
              showDenyButton: true,
              showConfirmButton: true,
              reverseButtons:true
            }).then((value) => {
              console.log(value)
              this.selectedFinalizado = true
              this.showModalMsgUpdating = true
              this.showModalRelatTFA = false

              let endwmsfa = null
              if (value.isConfirmed) {
                Swal.fire({
                  icon: 'success',
                  position: 'top-end',
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: "Estoque escolhido: FALTA",
                  timer: 1500
                })
                endwmsfa = 'FALTA'
              } else if (value.isDenied) {
                Swal.fire({
                  icon: 'success',
                  position: 'top-end',
                  showCancelButton: false,
                  showConfirmButton: false,
                  title: "Estoque escolhido: AVARIA",
                  timer: 1500
                })
                endwmsfa = 'AVARIA'
              }

              this.updating = true

              api.post(`${getBaseUrl()}api/wmsosfinalsepentrada`, {
                'endwmsfa': endwmsfa ?? null,
                'listitensfa': this.dtListRelatTFA,
                'idwmsos': this.idData
              }).then((res) => {
                this.selectedFinalizado = false
                this.showModalMsgUpdating = false
                this.updating = false
                console.log('then axios finalizarParcial')
                console.log(res.data)

                let flag = res.data.success ?? false

                if(flag){
                  Swal.fire({
                    icon: 'success',
                    position: 'top-end',
                    showCancelButton: false,
                    showConfirmButton: false,
                    title: 'Entrada gerada com sucesso!',
                    timer: 1500
                  }).then(() => {
                    this.atualizaPagina()
                  })
                }else{
                  Swal.fire({
                    icon: 'error',
                    position: 'top-end',
                    showCancelButton: false,
                    showConfirmButton: false,
                    text: res.data.message,
                    timer: 3000
                  })
                }
                this.showListConfig = false
              }).catch((e) => {
                console.log('error...')
                console.log(e)
              })
            })
          } else if (value.isDismissed) {
            this.showModalRelatTFA = false

            Swal.fire({
              icon: 'info',
              position: 'top-end',
              showCancelButton: false,
              showConfirmButton: false,
              title: "Operação cancelada",
              timer: 1500
            })
          }
      })
    },

    reiniciar() {
      console.log('reiniciar')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Reiniciar Conferência",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          // console.log(result.value)
          // console.log('vai')
          this.wmsOsItemData['idwmsos'] = this.idData
          this.updatingListas = true

          api.post(`${getBaseUrl()}api/wmsosreinicia`, {
            'iddata': this.idData
          }).then((res) => {
            console.log('then axios separar2_1')
            console.log(res.data)
            this.wmsOsItensSeparados = {}
            this.wmsOsItemData.produto = ''

            this.wmsOsItensData = res.data[0]

            if (this.wmsOsItensData.length > 0) {
              this.wmsOsItensData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(',')
                  value.img1 = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
                }
              })
            }

            this.wmsOsData = res.data[1]
            this.updatingListas = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Comando Reiniciar executado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.atualizaPagina()
            })
          })
        }
      })

    },

    nomeOrigem(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'movcompra':
          result = 'Compra'
          break
        case 'pedido':
          result = 'Pedido'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    informouProduto() {
      console.log('informouProduto')
      this.wmsOsItensData.forEach((value) => {
        if (value.produto === this.wmsOsItemSepData.produto){
          this.wmsOsItemSepData.produto_id = value.produto_id
          this.wmsOsItemSepData.descprod = value.descprod
        }
      })
      this.$refs.lote.focus()
    },


    finalizarSep() {

      if (this.wmsOsItemData.length === this.wmsOsItensSeparados.length){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Todos os itens precisam ser confirmados antes de finalizar",
          showConfirmButton: false,
          timer: 1500
        })
      } else {

        console.log('finalizarSep')


        Swal.fire({
          position: "center",
          icon: "question",
          title: "Finalizar Separação",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.updating = true
            api.get(`${getBaseUrl()}api/wmsosfinal`, {
              params: {
                'iddata': this.idData,
              }
            }).then((res) => {
              console.log('then axios finalizar')
              console.log(res.data)

              this.carregarDados()
              this.carregarDadosItens()

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações salvas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })

          }
        })
      }
    },


    novoProduto() {
      console.log('novoProduto')
      this.wmsOsItemSepData = {}
      this.showModalSepara = true
    },

    novoProdutoSelected(data){
      console.log('novoProdutoSelected')
      console.log(data)

      this.wmsOsItemSepData = {
        produto: data.produto,
        deflote: data.deflote
      }
      console.log(`wmsOsItemSepData: ${JSON.stringify(this.wmsOsItemSepData)}`)

      this.obrigInfoLote = data.deflote

      this.showModalSepara = true
      this.informouProduto()
    },



    informouQtd() {
      console.log('informouQtd')
      console.log(this.wmsOsItemSepData.qtd)

      console.log(this.wmsOsItemSepDataDisp)

      if (this.wmsOsItemSepData.qtd > 0  && this.wmsOsItemSepData.qtd <= this.wmsOsItemSepDataDisp && this.wmsOsItemSepData.palete && this.wmsOsItemSepData.endwms){
        this.confirmarSeparacao()
      }

      // this.wmsOsItemSepDataDisp = 32
      //
      // this.loadingWmsEnder = true
      //
      // api.post(`${getBaseUrl()}api/wmsositconfsep`, {
      //   'wmsOsItemSepData': this.wmsOsItemSepData,
      // }).then((res) => {
      //   console.log('then axios separar1')
      //   console.log(res.data)
      //
      //
      //
      //
      //   // this.wmsOsItemData.stswms = 'SE'
      //   //
      //   // //this.wmsOsData = res.data
      //   // // this.idData = res.data[0].id
      //   // // this.$router.replace({ path: `/movcompra/editar/${this.idData}` })
      //   // // this.carregarDados()
      //   // // this.carregarDadosItens()
      //   // this.showModalSepara = false
      //
      //   Swal.fire({
      //     position: "top-end",
      //     icon: "success",
      //     title: "Separação confirmada com sucesso!",
      //     showConfirmButton: false,
      //     timer: 1500
      //   })
      // })


    },

    informouPalete() {
      console.log('informouPalete')
      this.$refs.produto.focus()

      api.get(`${getBaseUrl()}api/wmsendcod`, {
        params: {coddata: this.wmsOsItemSepData.palete}
      }).then((res) => {
        console.log('then axios endwms')
        console.log(res.data)
        if (res.data[0]){
          this.wmsOsItemSepData.endwms = res.data[0]['descricao']
        }
      })
    },

    informouLote() {
      console.log('informouLote')
      console.log(this.wmsOsItemSepData.produto)

      let qtdDispLoc = 0
      this.wmsOsItensData.forEach((value) => {
        if (value.produto === this.wmsOsItemSepData.produto
        ){
          console.log('value')
          console.log(value)
          qtdDispLoc += value.qtd
        }
      })
      console.log('qtdDispLoc')
      console.log(qtdDispLoc)

      let debidoSeparado = 0
      this.wmsOsItensSeparados.forEach((value) => {
        if (value.produto === this.wmsOsItemSepData.produto){
          debidoSeparado = debidoSeparado + value.qtdlida
        }
      })
      console.log('debidoSeparado')
      console.log(debidoSeparado)

      if (debidoSeparado > 0){
        this.wmsOsItemSepData.disp = qtdDispLoc - debidoSeparado
      } else {
        this.wmsOsItemSepData.disp = qtdDispLoc
      }

      this.wmsOsItemSepData.qtd = this.wmsOsItemSepData.disp
      this.$refs.dtvalid.focus()
    },



    informouDtValid() {
      console.log('informouDtValid')
      this.$refs.qtdsep.focus()

    },



    confirmarSeparacao() {
      console.log('confirmarSeparacao')
      if (
          this.wmsOsItemSepData.deflote &&
          (
              !this.wmsOsItemSepData.lote ||
              this.wmsOsItemSepData.lote === null ||
              this.wmsOsItemSepData.lote === undefined ||
              this.wmsOsItemSepData.lote.trim() === ""
          )
      ) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Lote é obrigatório!",
          showConfirmButton: true,
        });

        return;
      }

      this.loadingWmsEnder = true
      // console.log(this.wmsOsItemSepData.produto)
      // console.log(this.wmsOsItemSepData.produto_id)

      api.post(`${getBaseUrl()}api/wmsositconfsep`, {
        'idwmsos': this.idData,
        'produto_id': this.wmsOsItemSepData.produto_id,
        'produto': this.wmsOsItemSepData.produto,
        'palete': this.wmsOsItemSepData.palete,
        'endwms': this.wmsOsItemSepData.endwms,
        'lote': this.wmsOsItemSepData.lote,
        'dtvalid': this.wmsOsItemSepData.dtvalid,
        'qtd': this.wmsOsItemSepData.qtd,
        'stsocor': this.wmsOsItemSepData.stsocor,
        'tipoocor': this.wmsOsItemSepData.tipoocor,
      }).then((res) => {
        console.log('then axios separar2')
        console.log(res.data)

        this.wmsOsItensSeparados = res.data[0]

        this.loadingWmsEnder = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Separação salva com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

        this.wmsOsItemSepData = {}
        this.showModalSepara = false
        this.carregarDadosItens()

        if(this.wmsOsData.qtd === this.wmsOsData.qtdlida && this.wmsOsData.qtddisp == 0){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Separação completa, finalizando entrada!",
            showConfirmButton: false,
            timer: 3000
          }).then(() => {
            this.finalizarSep()
          })
        }
      })
    },

    validaFinalizacao(tipoConferencia){
      console.log('validaFinalizacao')

      let validado = true
      this.wmsOsItensSeparados.forEach((item) => {
        if(item.deflote && (item.lote.trim() === "" || item.lote === null)) {
          validado = false
        }
      })

      if(!validado) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Existem itens obrigatórios de definição de lote!",
          showCancelButton: false,
          showConfirmButton: true,
        })

        return
      }

      if(tipoConferencia === 'todos'){
        console.log('conferindo todos')
        this.disparaConfirmacaoSepTodos()
      }/*else{
        console.log('conferindo itens')
        this.finalizarSep()
      }*/
    },

    disparaConfirmacaoSepTodos(){
      console.log('disparaConfirmacao')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Receber Todos Itens",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.isConfirmed) {
          Swal.fire({
            position: "top-end",
            icon: "info",
            title: "Recebendo todos os ites da compra!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.showModalSeparaTodos2 = false
            this.wmsOsItemData['idwmsos'] = this.idData
            this.updatingListas = true

            api.post(`${getBaseUrl()}api/wmsosseptodosentrada`, {
              'iddata': this.idData,
              'sepTodos': this.sepTodos,
            }).then((res) => {
              this.showModalSeparaTodos2 = false
              console.log('then axios receber todos')
              console.log(res.data)
              this.wmsOsData = res.data[1]
            }).then(() => {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Processo executado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.atualizaPagina()
              })
            })
          })
        }
      })
    },

    atualizaPagina() {
      window.location.reload();
    },


    enderecarProduto(itemData){
      console.log('enderecarProduto')
      this.wmsOsItemData = itemData

      api.get(`${getBaseUrl()}api/wmsositconfsep`, {
        params: {idData: this.wmsOsItemData.id}
      }).then((res) => {
        console.log('then axios separa0')
        console.log(res.data)

        this.wmsOsItemSepDataList = res.data[0]

        let valorSeparado = 0
        this.wmsOsItemSepDataList.forEach((value) => {
          valorSeparado += value.qtd
        })
        this.wmsOsItemSepDataDisp = this.wmsOsItemData.qtd - valorSeparado
        this.wmsOsItemSepData.qtd = this.wmsOsItemSepDataDisp

        this.showModalSepara = true

        // this.$refs.palete.focus()

        // this.mediaJsonCorpem = res.data[0]
        //
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Integração Realizada com Sucesso",
        //   text: this.mediaJsonCorpem.objretorno,
        //   showConfirmButton: false,
        //   timer: 2500
        // })

        this.updating = false

      })




    },


    onPageChange(){
      console.log('onPageChange')
      console.log(this.currentPage)
      this.carregarDadosItens()
    },

    abrirFinanceiro(){
      console.log('abrirFinanceiro')

      const routeData = this.$router.resolve(`/cpagar/editar/${this.financeiroData.id}`)
      window.open(routeData.href, '_blank')

    },






    deletarWmsOsItemSep(iditem){
      console.log('deletarWmsOsItem')
      console.log(iditem)

      if (this.wmsOsData.status === 'AB'){
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Exclusão de Registro",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.updating = true
            api.delete(`${getBaseUrl()}api/wmsositemsep`, {
              params: {
                'iddata': iditem
              }
            }).then((res) => {
              console.log('then axios delete')
              console.log(res.data)
              this.carregarDados()
              this.carregarDadosItens()
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })

          }
        })
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    calculaTotalItem(){
      console.log('calculaTotalItem')

      let quant = this.wmsOsItemData.qtd
      let vlrUnit = this.wmsOsItemData.vlrunitliq
      let vlrUnitTab = this.wmsOsItemData.vlrunitbrt
      let percDesc = 0

      if (quant > 0 && vlrUnit > 0){

        let valorTotalItem = quant * vlrUnit
        console.log('valorTotalItem')
        console.log(valorTotalItem)

        if (vlrUnit !== vlrUnitTab){
          percDesc = (1 - (vlrUnit / vlrUnitTab)) * 100
        }


        this.wmsOsItemData.desconto = percDesc
        this.wmsOsItemData.vlrtotalbrt = vlrUnitTab * quant
        this.wmsOsItemData.vlrtotalliq = valorTotalItem
      }

    },

    confMovCompraItem(){
      console.log('confMovCompraItem: ' + this.idData)
      this.v$.$touch()
      this.submitMovCompraItem = true

      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.loadingMovCompraItem = true

        api.post(`${getBaseUrl()}api/movcompraitem`, {
          wmsOsItemData: this.wmsOsItemData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.produtoData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.loadingMovCompraItem = false
          this.showModalMovCompraItem = false
          this.carregarDados()
          this.carregarDadosItens()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })

      }
    },

    detalhesProduto(idProd){
      console.log('detalhesProduto: ' + idProd)

      this.$router.push(`/produto/detalhe/${idProd}`);

      // let route = this.$router.resolve({ path: "/contact" });
      // window.open(route.href);


    },

    editarProduto(idProd){
      console.log('editarProduto: ' + idProd)

      if (this.wmsOsData.status === 'EL'){
        this.showModalMovCompraItem = true
        this.loadingMovCompraItem = true

        api.get(`${getBaseUrl()}api/movcompraitem`, {
          params: { iddata: idProd }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data[0])

          this.wmsOsItemData = res.data[0]

          if (this.wmsOsItemData.imgs){
            let imgTrat = this.wmsOsItemData.imgs.split(',')
            this.wmsOsItemData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          }

          this.loadingMovCompraItem = false
        })
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmar(){
      console.log('confirmar: ' + this.idData)

      if (!this.wmsOsItensData || this.wmsOsItensData.length <= 0){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor adicionar produto a compra antes de confirmar",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Confirmação de Compra",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          if (result.value) {
            this.updating = true
            api.post(`${getBaseUrl()}api/movcompraconf`, {
              iddata: this.idData
            }).then((res) => {
              console.log('then axios')
              console.log(res)

              this.updating = false
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Compra confirmada com sucesso",
                showConfirmButton: false,
                timer: 1500
              }).then((res) =>{
                console.log(res)
                this.$router.push(`/wmsos/list`)

              })
            })
          }
        })
      }
    },

    redirecionandoParaConfer() {
      console.log('redirecionandoParaConfer')

      const routeData = this.$router.resolve(`/coletor/recebimentocoletor/${this.idData}`)
      window.open(routeData.href, '_blank')

    },

    nomeStatus(stsIn){
      let result = 'Não Definido'
      switch (stsIn) {
        case 'AB':
          result = 'Aberto'
          break
        case 'SE':
          result = 'Separado'
          break
        case 'CA':
          result = 'Cancelado'
          break
      }
      return result
    },

    nomeStatusWms(stsIn){
      let result = 'Não Conferido'
      switch (stsIn) {
        case 'SE':
          result = 'Conferido'
          break
      }
      return result
    },

    nomeStswms(e) {
      switch (e.value) {
        case 'SE':
          return 'Conferido'

        default:
          return 'Não Conferido'
      }
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "stswms") {

          const stsWms = e.data.stswms
          const endwms = e.data.endwms
          let corStatus = 'rgba(223,121,106,0.98)'

          switch (stsWms) {
            case 'SE':
              if (endwms === "FALTA" || endwms === "AVARIA") {
                  corStatus = 'rgb(251,174,27)'
              } else {
                corStatus = 'rgba(46,184,134,0.96)'
              }
              break
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }


        if (e.column.dataField === "endwms") {
          const endwms = e.data.endwms
          let corStatus = "";

          if (endwms === "FALTA" || endwms === "AVARIA") {
            corStatus = 'rgb(251,174,27)'
            e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

      }

    },

    alteraObs(){
      console.log('alteraObs')
      if (this.wmsOsData.status === 'EL'){
        this.showModalObs = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    carregarDados(){
      api.get(`${getBaseUrl()}api/wmsos`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios wmsosEditar')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))

        this.wmsOsData = res.data[0]
        this.fornecedorData = res.data[3]
        // this.pedTipoData = res.data[2]
        // this.formaPgtoData = res.data[3]
        // this.condPgtoData = res.data[4]
        // // this.wmsOsItensData = res.data[5]
        // this.mediasData = res.data[6]
        // this.mediaJsonCorpem = res.data[7]
        // this.financeiroData = res.data[8]
        // this.mediasAnexoData = res.data[9]

        // if (this.wmsOsItensData && this.wmsOsItensData.length > 0){
        //   this.wmsOsItensData.forEach((value) => {
        //     if (value.imgs) {
        //       let imgTrat = value.imgs.split(',')
        //       value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
        //       let valor = parseFloat(value.vlrtotalliq)
        //       this.valorTotalItens += valor
        //     }
        //   });
        // }

        this.idData = this.wmsOsData.id
        this.title = `Editar OS Entrada (${this.wmsOsData.id})`
        this.updating = false
      })

      // api.get(`${getBaseUrl()}api/emsositem`, {
      //   params: { iddata: this.idData }
      // }).then((res) => {
      //
      //   console.log('res itens')
      //   console.log(res)
      //   this.wmsOsItensData = res.data
      //
      // })

    },



    carregarDadosItens(){
      console.log('carregarDadosItens')
      this.updating = true
      this.loadingList = true

      api.get(`${getBaseUrl()}api/wmsosit`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {

        console.log('res carregarDadosItens')
        console.log(res.data)
        // console.log(JSON.stringify(res.data))
        this.loadingList = false

        // this.totalItens = res.data.total
        this.wmsOsItensData = res.data[0]
        this.wmsOsItensSeparados = res.data[1]
        this.wmsOsItensAgrup = res.data[2]

        let totalItens = 0
        let fatalSep = []
        this.wmsOsItensData.forEach((value) => {
          totalItens += parseFloat(value.qtd)
          let existeSep = false
          this.wmsOsItensSeparados.forEach((valueF) => {
            if (value.produto === valueF.produto &&
                value.lote === valueF.lote &&
                value.qtd === valueF.qtd){
              existeSep = true
            }
          })
          if (existeSep === false){
            fatalSep.push(value)
          }
        })

        let totalItensSep = 0
        this.wmsOsItensSeparados.forEach((value) => {
          if(value.endwms !== ('FALTA') && value.endwms !== ('AVARIA')) {
            totalItensSep += parseFloat(value.qtdsep)
          }
        })

        this.wmsOsItensFaltaData = fatalSep
        this.contTotalItens = totalItens
        this.contTotalItensSep = totalItensSep

        this.contTotalFalta = totalItens - totalItensSep

        this.percTotalSeparado = this.contTotalItensSep / this.contTotalItens * 100

        //Garantindo que ele é false caso apenas chame a função
        this.validacaoLote = false

        this.wmsOsItensData.forEach(item => {
          if(item.deflote && (!item.lote || item.lote.trim() === "")) {
            this.validacaoLote = true
          }
        })

        this.updating = false
      })
    },

    selecionaCli(){
      console.log('selecionaCli')
      if (this.wmsOsData.status === 'EL'){
        this.showModalFornecedor = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaCondPgto(){
      console.log('selecionaCondPgto')
      if (this.wmsOsData.status === 'EL') {
        this.showModalCondPgto = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaFormaPgto(){
      console.log('selecionaFormaPgto')
      if (this.wmsOsData.status === 'EL') {
        this.showModalFormaPgto = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaPedTipo(){
      console.log('selecionaPedTipo')
      if (this.wmsOsData.status === 'EL') {
        console.log(this.wmsOsData.tipo)
        this.showModalPedTipo = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaMovCompraItem(){
      console.log('selecionaMovCompraItem')
      if (this.wmsOsData.status === 'EL') {
        this.showModalMovCompraItem = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarFornec(){
      console.log('confirmarFornec')
      this.showModalFornecedor = false
      this.salvar()
    },
    confirmarCondPgto(){
      console.log('confirmarCondPgto')
      this.showModalCondPgto = false
    },
    confirmarFormaPgto(){
      console.log('confirmarFormaPgto')
      this.showModalFormaPgto = false
    },
    confirmarPedTipo(){
      console.log('confirmarPedTipo')
      this.showModalPedTipo = false
    },
    confirmarMovCompraItem(){
      console.log('confirmarMovCompraItem')
      this.showModalMovCompraItem = false
    },

    pesqFornec(evt){
      console.log('pesqFornec')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query, c: 'FO' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqFor = res.data
        });
      }
    },

    pesqCondPgto(evt){
      console.log('pesqCondPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingCondPgto = true
        this.wmsOsData.condpgto = ''
        api.get(`${getBaseUrl()}api/cpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCondPgto = res.data
        })
      }
    },

    pesqFormaPgto(evt){
      console.log('pesqFormaPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingFormaPgto = true
        this.wmsOsData.formapgto = ''
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFormaPgto = res.data
        })
      }
    },

    pesqWmsEnder(evt){
      console.log('pesqWmsEnder')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingWmsEnder = true
        this.wmsOsItemData.endwms = ''
        api.get(`${getBaseUrl()}api/wmsendpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqWmsEnder = res.data
        })
      }
    },

    pesqPedTipo(evt){
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingPedTipo = true
        this.wmsOsData.tipo = ''
        api.get(`${getBaseUrl()}api/tpoprpesq`, {
          params: { q: query, t: 'E', f: this.wmsOsData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPedTipo = res.data
        })
      }
    },

    pesqMovCompraItem(evt){
      console.log('pesqMovCompraItem')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqMovCompraItem = null
        this.loadingMovCompraItem = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqMovCompraItem = res.data

          this.dtlistPesqMovCompraItem.forEach((value) => {
            let imgTrat = value.imgs.split(',')
            value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          });

        })
      }
    },

    escolheuFor(){
      console.log('escolheuFor')
      this.loadingFornec = true
      console.log(this.wmsOsData.fornec)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.wmsOsData.fornec }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.fornecedorData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingFornec = false
      })
    },

    escolheuCondPgto(){
      console.log('escolheuCondPgto')
      this.loadingCondPgto = true
      console.log(this.wmsOsData.condpgto)
      api.get(`${getBaseUrl()}api/cpgtocod`, {
        params: { coddata: this.wmsOsData.condpgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.condPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingCondPgto = false
      })
    },

    escolheuFormaPgto(){
      console.log('escolheuFormaPgto')
      this.loadingFormaPgto = true
      console.log(this.wmsOsData.formapgto)
      api.get(`${getBaseUrl()}api/fpgtocod`, {
        params: { coddata: this.wmsOsData.formapgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.formaPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingFormaPgto = false
      })
    },

    escolheuWmsEnder(){
      console.log('escolheuWmsEnder')
      this.loadingWmsEnder = true

       console.log('this.wmsOsItemData.endwms')
       console.log(this.wmsOsItemData.endwms)

      api.get(`${getBaseUrl()}api/wmsendcod`, {
        params: { coddata: this.wmsOsItemData.endwms }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.wmsEnderData = res.data[0]
        // this.ultPedsData = res.data[1]

        // let totalPed = 0
        // this.ultPedsData.forEach((value) => {
        //   totalPed += value.valorliq
        // });

        // this.somaPedidosFor = totalPed
        this.loadingWmsEnder = false
        //this.showModalSepara = false
      })
    },

    escolheuPedTipo(){
      console.log('escolheuPedTipo')
      this.loadingPedTipo = true
      console.log(this.wmsOsData.tipo)
      api.get(`${getBaseUrl()}api/tpoprcod`, {
        params: { coddata: this.wmsOsData.tipo }
      }).then((res) => {
        console.log('then axios_escolheu_ped_tipo')
        console.log(res.data)
        this.pedTipoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingPedTipo = false
      })
    },

    escolheuMovCompraItem(){
      console.log('escolheuItem')
      this.loadingMovCompraItem = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.wmsOsItemData.produto }
      }).then((res) => {
        console.log('then axios_escolheu_ped_item')
        console.log(res.data)
        this.wmsOsItemData = {
          movcompra_id: this.idData,
          produto: res.data[0]['codigo'],
          descprod: res.data[0]['descricao'],
          und: res.data[0]['unidade'],
          vlrunitliq: res.data[0]['preco'],
          vlrunitbrt: res.data[0]['preco'],
          vlrtotalliq: res.data[0]['preco'],
          vlrtotalbrt: res.data[0]['preco'],
          img1: `${getBaseUrl() + '_IMG'}/peq/${res.data[0]['imgs']}`,
          qtd: 1
        }
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingMovCompraItem = false
      })
    },

    salvar(){
      console.log('salvar')
      if (this.wmsOsData.fornec && this.wmsOsData.fornec !== ''){
        console.log('salvar_00')
        this.updating = true

        this.errosValid = []
        api.post(`${getBaseUrl()}api/movcompra`, {
          wmsOsData: this.wmsOsData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.wmsOsData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          if (this.idData === 0){
            console.log('redirecionar')
            this.$router.replace({ path: `/movcompra/editar/${this.wmsOsData.id}` })
            this.idData = this.wmsOsData.id
            this.carregarDados()
            this.carregarDadosItens()
          }

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })



      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar fornecedor antes de salvar a compra",
          showConfirmButton: false,
          timer: 1500
        })
      }

    },

    carregouGrid(e) {
      console.log("carregouGrid");
      console.log(e);
    },

    onExporting(e) {
      console.log("onExporting");
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("plan1");
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              this.title + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log("refeFormTable");
      this.dataGrid.state(null);
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="wmsOsData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">

<!--      <div class="col-lg-12" v-if="wmsOsData.status !== 'SE'">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

&lt;!&ndash;              <b-button :disabled="wmsOsData.status !== 'AB'" variant="outline-warning" class="mx-2" @click="abrirRomaneio" v-if="wmsOsData.wmsroma_id">&ndash;&gt;
&lt;!&ndash;                <i class="bx bx-fullscreen font-size-16 align-middle me-2"></i>&ndash;&gt;
&lt;!&ndash;                Romaneio&ndash;&gt;
&lt;!&ndash;              </b-button>&ndash;&gt;

&lt;!&ndash;              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="integrCorpem">&ndash;&gt;
&lt;!&ndash;                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>&ndash;&gt;
&lt;!&ndash;                Integração Corpem&ndash;&gt;
&lt;!&ndash;              </b-button>&ndash;&gt;

&lt;!&ndash;
              <b-button :disabled="wmsOsData.status !== 'AB'"  variant="outline-info" class="mx-2" @click="validaFinalizacao('itens')">
                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>
                Finalizar Separação
              </b-button>
&ndash;&gt;

&lt;!&ndash;              <b-button variant="outline-danger" class="mx-2" @click="exibirTodos = !exibirTodos">
                <i class="bx bxs-layer font-size-16 align-middle me-2"></i>
                {{ exibirTodos === false ? 'Faltando Separação' : 'Apenas Separados' }}
              </b-button>&ndash;&gt;

&lt;!&ndash;              <b-button variant="outline-info"
                        class="mx-2"
                        @click="associarSaldo"
                        v-if="userLogged && userLogged.email === 'admin@admin.com.br'">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Associar a Saldo (APENAS ADMIN)
              </b-button>&ndash;&gt;

&lt;!&ndash;              <b-button variant="outline-danger" class="mx-2" @click="cancelar"  >
                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>&ndash;&gt;

&lt;!&ndash;              <button&ndash;&gt;
&lt;!&ndash;                  class="btn btn-success"&ndash;&gt;
&lt;!&ndash;                  @click="confirmar"&ndash;&gt;
&lt;!&ndash;                  :disabled="wmsOsData.status !== 'EL'"&ndash;&gt;
&lt;!&ndash;                  v-if="wmsOsData.status === 'EL' && wmsOsItensData && wmsOsItensData.length > 0">&ndash;&gt;
&lt;!&ndash;                <i class="mdi mdi-check-circle me-1 text-end"></i> CONFIRMAR&ndash;&gt;
&lt;!&ndash;              </button>&ndash;&gt;


            </div>
          </div>
        </div>
      </div>-->

      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
        favor ajustar e tentar novamente.
      </b-alert>

      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <PageActionBar
              v-if="wmsOsData.status !== 'SE'"
              class="mb-5"
              :primary-actions="[
                { label: 'Novo Produto', icon: 'bx bx-plus-circle', variant: 'outline-success', onClick: novoProduto, disabled: wmsOsData.status !== 'AB' },
                { label: 'Finalizar Separação', icon: 'bx bx-check-double', variant: 'outline-success', onClick: confSepararTodos, disabled: (contTotalItensSep < 1) || idData === 0 || wmsOsData.status === 'SE' },
              ]"
              :secondary-actions="[
                { label: 'Reiniciar', icon: 'bx bx-sync', variant: 'outline-warning', onClick: reiniciar, disabled: wmsOsData.status === 'SE' || (contTotalItensSep < 1) },
                { label: 'Receber todos', icon: 'bx bx-check-double', variant: 'outline-primary', onClick: () => showModalSeparaTodos2 = true, disabled: wmsOsData.status !== 'AB' || validacaoLote === true, visible: wmsOsItensData.length > 0 },
                { label: 'Ir para Separação', icon: 'bx bx-list-check', variant: 'info', onClick: redirecionandoParaConfer, disabled: wmsOsData.status !== 'AB' || validacaoLote === true, visible: wmsOsItensData.length > 0 },
              ]"
            />

            <div class="row mb-3">
              <div class="d-flex col-4">
                <div class="me-3">
                  <span
                      v-if="fornecedorData"
                      class="avatar-title rounded-circle"
                      style="max-height: 55px;
                      min-width: 55px;">{{ fornecedorData.codigo }}
                  </span>
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">

                        <a  v-if="!fornecedorData" >
                          <h5 class="mb-1 text-info">Separado {{ formatDecimal(percTotalSeparado) }} %</h5>
                        </a>

                        <a href="javascript: void(0);" v-if="fornecedorData" @click="selecionaCli">
                          <h5 class="mb-1">{{ fornecedorData.codigo }} - {{ fornecedorData.nome }}</h5>
                          <p class="mb-0">{{ fornecedorData.cidade }}, {{ fornecedorData.estado }}</p>
                        </a>

                      </div>
                    </div>

                    <router-link :to="`/cliente/detalhe/${fornecedorData.id}`" class="ms-2" v-if="fornecedorData" target="_blank">
                      Detalhes Fornecedor
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </router-link>
                  </div>
                </div>
              </div>

              <div class="col-1 d-flex justify-content-center">
                <hr style="width: 1px;height: 100px;background-color: #000;border: none;margin: 0 10px;">
              </div>

              <div class="row col-6">
                <h5>Dados itens</h5>
                <div class="col-3">
                  <div>
                    <p class="text-muted text-truncate mb-2" v-if="wmsOsItensData">Itens</p>
                    <h5 class="mb-0">{{ formatDecimal(contTotalItens) }}</h5>
                  </div>
                </div>

                <div class="col-3">
                  <div>
                    <p class="text-muted text-truncate mb-2">Peso Total</p>
                    <h5 class="mb-0">{{ wmsOsData.peso ?? formatDecimal(wmsOsData.peso) }} kg</h5>
                  </div>
                </div>

                <div class="col-3">
                  <div class="text-center">
                    <p class="text-muted text-truncate mb-2">Separados</p>
                    <h4 class="mb-0 text-info">{{ formatInteger(contTotalItensSep) }} </h4>
                  </div>
                </div>

                <div class="col-3">
                  <div class="text-center">
                    <p class="text-muted mb-2">Faltas</p>
                    <h4 class="mb-0 text-danger">{{ formatInteger(contTotalFalta) }} </h4>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">

              <div class="table-responsive">
                <div class="d-flex">
                  <h4 >Espelho de Conferência</h4>
                  <i class="bx bx-list-check font-size-20 ms-1"></i>
<!--                  <DxToolbar>
                    <DxItem location="before" widget="dxButton">
                      <DxButton
                          icon="refresh"
                          hint="Redefinir formatação de tabela para padrão"
                          :on-click="refeFormTable"
                      />
                    </DxItem>
                  </DxToolbar>-->
                </div>
                <div class="mt-0" v-if="!updating">
                  <DxDataGrid
                      ref="dataGridRefKey"
                      :data-source="wmsOsItensAgrup"
                      :show-borders="true"
                      :focused-row-enabled="true"
                      :keyExpr="'id'"
                      :column-auto-width="true"
                      :show-row-lines="true"
                      :allow-column-reordering="true"
                      :allow-column-resizing="true"
                      :row-alternation-enabled="true"
                      @content-ready="carregouGrid"
                      @cell-prepared="onCellPrepared"
                      @exporting="onExporting"
                  >
                    <DxRemoteOperations
                        :filtering="true"
                        :paging="true"
                        :sorting="true"
                        :summary="true"
                        :grouping="false"
                        :group-paging="false"
                    />

                    <DxColumnChooser :enabled="true" />
                    <DxColumnFixing :enabled="true" />
                    <DxFilterRow :visible="false" />

                    <!--                  <DxSelection mode="multiple" />-->

                    <DxExport
                        :enabled="true"
                        :allow-export-selected-data="true"
                    />
                    <DxStateStoring
                        :enabled="true"
                        type="sessionStorage"
                        storage-key="strWmsOsEntradaList"
                    />

                    <DxGroupPanel :visible="false" />
                    <DxGrouping />

                    <DxColumn
                        :width="60"
                        data-field="id"
                        caption="ID"
                        sort-order="desc"
                        data-type="number"
                        alignment="right"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="produto"
                        caption="Produto"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="descprod"
                        caption="Descrição"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="stswms"
                        caption="Status"
                        data-type="text"
                        alignment="center"
                        :customize-text="nomeStswms"
                        :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="qtd"
                        caption="Qtd. Conf."
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"/>

                    <DxColumn
                        data-field="qtdlida"
                        caption="Qtd. Lida"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"/>

                    <DxColumn
                        data-field="qtdfalta"
                        caption="Qtd. Falta"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"/>

                    <DxColumn
                        data-field="peso"
                        caption="Peso"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"/>

                    <DxColumn
                        data-field="lote"
                        caption="Lote"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="serie"
                        caption="Serie"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="palete"
                        caption="Palete"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        data-field="endwms"
                        caption="Endereço"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                        :allowHeaderFiltering="false"
                    />

                    <DxColumn
                        :width="150"
                        data-field="dtvalid"
                        caption="Dt. Validade"
                        alignment="right"
                        :format="formatDate"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                    />

                    <DxPager
                        :visible="true"
                        :show-page-size-selector="true"
                        :allowed-page-sizes="[10, 30, 50, 100]"
                        :show-navigation-buttons="true"
                        :show-info="true"
                    />
                  </DxDataGrid>
                </div>

                <Loader v-if="loadingList" style="min-height: 300px;">
                </Loader>
              </div>
            </div>

          </div>
        </div>

<!--        <div class="card">
          <div class="card-body">
            <h6>Dados itens</h6>
            <div class="row">
              <div class="col-4">
                <div>
                  <p class="text-muted text-truncate mb-2" v-if="wmsOsItensData">Itens</p>
                  <h5 class="mb-0">{{ formatDecimal(contTotalItens) }}</h5>
                </div>
              </div>


              <div class="col-4">
                <div>
                  <p class="text-muted text-truncate mb-2">Peso Total</p>
                  <h5 class="mb-0">{{ wmsOsData.peso ?? formatDecimal(wmsOsData.peso) }} kg</h5>
                </div>
              </div>



              <div class="col-4">
                <div>
                  <p class="text-muted text-truncate mb-2">Separados</p>
                  <h4 class="mb-0 text-info">{{ formatInteger(contTotalItensSep) }} </h4>
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </div>

<!--      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">



&lt;!&ndash;            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th>Produto</th>
                  <th>Status</th>
                  <th class="text-end">Quantidade</th>
                  <th class="text-end">Separado</th>
                  <th class="text-end">Peso</th>
                  <th class="">Endereço</th>
                  <th class="">Lote</th>
                  <th class="">Validade</th>
&lt;!&ndash;                  <th class="text-end">Ações</th>&ndash;&gt;
                </tr>
                </thead>
                <tbody>

                <tr v-for="data in wmsOsItensAgrup" :key="data.id">
                  <td>
                    <a href="javascript: void(0);" class="text-body fw-bold  text-wrap">
                      <h5 class="text-muted mb-0">{{ data.produto }} </h5>
                      {{ data.descprod }}
                    </a>
                  </td>
                  <td>
                    <span class="badge badge-pill badge-soft-success font-size-11"
                          :class="data.stswms === 'SE' ? 'badge-soft-success' : 'badge-soft-danger' ">
                      {{ nomeStatusWms(data.stswms)  }}
                    </span>
                    <p v-if="data.stsocor === 'A'">
                    <span class="badge badge-pill badge-soft-success font-size-11 badge-soft-danger">
                      Ocorrência
                    </span>
                    </p>
                  </td>
                  <td class="text-end">{{ formatDecimal(data.qtd) }}</td>
                  <td class="text-end">{{ formatDecimal(data.qtdsep) }}</td>
                  <td class="text-end">{{ formatDecimal(data.peso) }}</td>
                  <td >
                    {{ data.endwms }}
                    <p>
                      {{ data.palete }}
                    </p>
                  </td>
                  <td class="text-end"> {{ data.lote }} </td>
                  <td class="text-end"> {{ data.dtvalid }} </td>
&lt;!&ndash;                  <td class="text-end">
                    <a href="javascript:void(0);"
                       v-if="wmsOsData.status === 'AB'"
                       class="action-icon text-danger mx-2"
                       @click="deletarWmsOsItemSep(data.idsep)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>&ndash;&gt;
                </tr>
                </tbody>
              </table>
            </div>&ndash;&gt;

&lt;!&ndash;            <div class="table-responsive" v-if="exibirTodos === true">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th>Produto</th>
                  &lt;!&ndash;                  <th>Status</th>&ndash;&gt;
                  <th class="text-end">Quantidade</th>
                  <th class="text-end">Separado</th>
                  <th class="text-end">Peso</th>
                  <th class="">Endereço</th>
                  <th class="">Lote</th>
                  <th class="">Validade</th>
                  <th class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="data in wmsOsItensFaltaData" :key="data.id">
                  <template v-if="data.qtdlida !== data.qtd">
                    <td>
                      <a href="javascript: void(0);" class="text-body fw-bold  text-wrap" @click="novoProdutoSelected(data)">
                        <h5 class="text-muted mb-0">{{ data.produto }} </h5>
                        {{ data.descprod }}
                      </a>
                    </td>
                    <td class="text-end">{{ formatDecimal(data.qtd) }}</td>
                    <td class="text-end">{{ formatDecimal(data.qtdlida) }}</td>
                    <td class="text-end">{{ formatDecimal(data.peso) }}</td>
                    <td >
                      {{ data.endwms }}
                      <p>
                        {{ data.palete }}
                      </p>
                    </td>
                    <td class="text-end"> {{ data.lote }} </td>
                    <td class="text-end"> {{ data.dtvalid }} </td>
                    <td class="text-end">
                    </td>
                  </template>
                </tr>
                </tbody>
              </table>
            </div>&ndash;&gt;


          </div>
        </div>
      </div>-->
    </div>

    <div class="row" v-if="!updating">
      <div class="col-xl-12">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItens"
                  @update:modelValue="onPageChange">
              </b-pagination>

            </ul>
          </div>
        </div>
      </div>
    </div>

    <b-modal :title="fornecedorData != null ? `Detalhes Fornecedor (${ fornecedorData.nome })` : 'Detalhes Fornecedor'" v-model="showModalFornecedor" centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <label for="cidade">Fornecedor</label>

          <multiselect @search-change="pesqFornec"
                       @select="escolheuFor"
                       v-model="wmsOsData.fornec"
                       placeholder="Pesquisar fornecedor"
                       :options="dtListPesqFor"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <div class="row" v-if="loadingFornec">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingFornec && fornecedorData">
        <router-link :to="`/cliente/detalhe/${fornecedorData.id}`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ fornecedorData.codigo }} </span>
          </p>
        </router-link>
          <p class="mb-2" >
              Endereço:
              <span> {{ fornecedorData.rua }}, {{ fornecedorData.numero }}, {{ fornecedorData.bairro }}  </span>
              <span> {{ fornecedorData.cidade }} - {{ fornecedorData.estado }} </span>
          </p>
        <p class="mb-4" >
          <span> {{ fornecedorData.tel1 }} / {{ fornecedorData.email }}</span>
        </p>
          <div class="table-responsive">
            <table class="table table-centered table-nowrap">
              <thead>
              <tr>
                <th scope="col">Últimas Compras</th>
                <th scope="col" class="text-end">Data</th>
                <th scope="col" class="text-end">Valor (R$)</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="data in ultPedsData" :key="data.id">
                <td>
                  <router-link :to="`/movcompra/editar/${data.id}`" target="_blank">
                    <div>
                      <h5 class="text-truncate font-size-14">
                        {{ data.codigo }}
                      </h5>
                    </div>
                  </router-link>
                </td>
                <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
                <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
                </td>
                <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
                </td>
                <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
              </tr>
              </tbody>
            </table>
          </div>

      </div>

      <div>
        <div class="text-start mt-5">
          <router-link  to="/cliente/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Novo Fornecedor
          </router-link>
        </div>
      </div>

      <div v-if="!loadingFornec && fornecedorData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalFornecedor = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFornec">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Detalhes Tipo de operação" v-model="showModalPedTipo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Novo Tipo de Operação</label>

          <multiselect id="tipooperacao"
                       @search-change="pesqPedTipo"
                       @select="escolheuPedTipo"
                       v-model="wmsOsData.tipo"
                       placeholder="Pesquisar tipo de operação"
                       :options="dtlistPesqPedTipo"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingPedTipo && pedTipoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ pedTipoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ pedTipoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Compras</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movcompra/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarPedTipo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Detalhes Forma de Pagamento" v-model="showModalFormaPgto" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="formapgto">Selecionar Nova Forma de Pagamento</label>

          <multiselect id="formapgto"
                       @search-change="pesqFormaPgto"
                       @select="escolheuFormaPgto"
                       v-model="wmsOsData.formapgto"
                       placeholder="Pesquisar forma de pagamento"
                       :options="dtListPesqFormaPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingFormaPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingFormaPgto && formaPgtoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ formaPgtoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Compras</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movcompra/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFormaPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFormaPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Detalhes Condição de Pagamento" v-model="showModalCondPgto" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="condpgto">Selecionar Nova Condição de Pagamento</label>

          <multiselect id="condpgto"
                       @search-change="pesqCondPgto"
                       @select="escolheuCondPgto"
                       v-model="wmsOsData.condpgto"
                       placeholder="Pesquisar condição de pagamento"
                       :options="dtListPesqCondPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4" >

                </span>
                <span class="mx-4" >

                  </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingCondPgto && condPgtoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2" >
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Compras</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movcompra/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarCondPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Alterar Observação" v-model="showModalObs" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="observacao">Favor informar as observações</label>
          <textarea
              id="obs"
              v-model="wmsOsData.obs"
              type="text"
              rows="3"
              class="form-control"
              placeholder="Observações"/>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalObs = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal size="lg"
             :title="wmsOsItemData.id != null ? `Editar Item da Compra (${ wmsOsItemData.id })` : 'Criar Novo Item na Compra'"
             v-model="showModalMovCompraItem"
             hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="cidade">Selecionar Novo Produto</label>
          <multiselect @search-change="pesqMovCompraItem"
                       @select="escolheuMovCompraItem"
                       v-model="wmsOsItemData.produto"
                       placeholder="Pesquisar novo produto"
                       :options="dtlistPesqMovCompraItem"
                       :searchable="true"
                       label="descricao"
                       class="multiselect-size"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps" v-if="dtlistPesqMovCompraItem">
              <div class="row" style="min-width: 100%;">

                <div style="min-width: 100%;">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-warning" >
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end" >

                  </span>
                </div>

                <div class="align-items-end text-end align-content-end float-end">
                  <div class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                  </div>


                  <span class="float-end ">
                    <span v-if="slotProps.option.saldo > 0" class="avatar-title rounded-circle bg-success avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                    <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                  </span>
                </div>


              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="loadingMovCompraItem">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingMovCompraItem && wmsOsItemData && wmsOsItemData.descprod">

        <router-link :to="`/produto/detalhe/${wmsOsItemData.produto_id}`" target="_blank" >
          <div class="row">

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <p class="text-muted mb-2">{{ wmsOsItemData.descprod }}</p>
                      <h5 class="mb-0">saldo: ({{ formatDecimal(wmsOsItemData.saldo) }})</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-sm ms-auto" v-if="!wmsOsItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div class="avatar-sm ms-auto" v-if="wmsOsItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <img class="rounded-circle avatar-xs" :src="wmsOsItemData.img1" alt />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span> <span class="text-info">   {{ wmsOsItemData.produto }} </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">R$ {{ formatDecimal(wmsOsItemData.vlrunitbrt) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>




<!--            <div class="col-lg-4">-->
<!--              <div class="card mini-stats-wid">-->
<!--                <div class="card-body">-->
<!--                  <div class="d-flex flex-wrap">-->
<!--                    <div class="me-2">-->
<!--                      <p class="text-muted mb-2">ICMS</p>-->
<!--                      <h5 class="mb-0"> Origem: {{ wmsOsItemData.icmsori }}, CST: {{ wmsOsItemData.icmscst }} </h5>-->
<!--                      <h5 class="mb-0"> Mod.BC.: {{ wmsOsItemData.icmsmodbc }}  ({{ formatDecimal(wmsOsItemData.icmsperc) }}%) </h5>-->
<!--                      <h5 class="mb-0"> Valor R$: {{ wmsOsItemData.icmsvlr }} </h5>-->

<!--                    </div>-->
<!--&lt;!&ndash;                    <div class="avatar-sm ms-auto">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">&ndash;&gt;-->
<!--&lt;!&ndash;                        <i class="bx bx-search-alt-2"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="col-lg-4">-->
<!--              <div class="card mini-stats-wid">-->
<!--                <div class="card-body">-->
<!--                  <div class="d-flex flex-wrap">-->
<!--                    <div class="me-2">-->
<!--                      <p class="text-muted mb-2">IPI</p>-->
<!--                      <h5 class="mb-0">Cenq: {{ wmsOsItemData.ipicenq }} </h5>-->
<!--                      <h5 class="mb-0">CST: {{ wmsOsItemData.ipicst }} </h5>-->
<!--                    </div>-->
<!--&lt;!&ndash;                    <div class="avatar-sm ms-auto">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">&ndash;&gt;-->
<!--&lt;!&ndash;                        <i class="bx bx-search-alt-2"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="col-lg-4">-->
<!--              <div class="card mini-stats-wid">-->
<!--                <div class="card-body">-->
<!--                  <div class="d-flex flex-wrap">-->
<!--                    <div class="me-2">-->
<!--                      <p class="text-muted mb-2">PIS / COFINS</p>-->
<!--                      <h5 class="mb-0">CST PIS: {{ wmsOsItemData.piscst }} </h5>-->
<!--                      <h5 class="mb-0">CST COFINS: {{ wmsOsItemData.cofinscst }} </h5>-->
<!--                    </div>-->
<!--&lt;!&ndash;                    <div class="avatar-sm ms-auto">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">&ndash;&gt;-->
<!--&lt;!&ndash;                        <i class="bx bx-search-alt-2"></i>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

          </div>
        </router-link>



          <form class="needs-validation" @submit.prevent="confMovCompraItem">

            <div class="row">

              <div class="col-md-4">
                <div class="mb-3">
                  <label for="lote">Lote</label>
                  <input
                      id="lote"
                      v-model="wmsOsItemData.lote"
                      type="text"
                      class="form-control"
                      placeholder="Lote de fabricação"/>
                </div>
              </div>

              <div class="col-md-4">
                <div class="mb-3">
                  <label for="dtfabric">Data de fabricação</label>
                  <input
                      id="dtfabric"
                      v-model="wmsOsItemData.dtfabric"
                      type="date"
                      class="form-control"
                      placeholder="Data de fabricação"/>
                </div>
              </div>

              <div class="col-md-4">
                <div class="mb-3">
                  <label for="dtvalid">Data de validade</label>
                  <input
                      id="dtvalid"
                      v-model="wmsOsItemData.dtvalid"
                      type="date"
                      class="form-control"
                      placeholder="Data de validade"/>
                </div>
              </div>

            </div>

            <div class="row">

              <div class="col-md-4">
                <div class="mb-3">
                  <label for="vlrunitliq">Valor Unitário</label>
                  <input
                      id="vlrunitliq"
                      v-model="wmsOsItemData.vlrunitliq"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor unitário líquido"
                      :class="{'is-invalid': submitMovCompraItem && v$.wmsOsItemData.vlrunitliq.$error,}"/>
                  <div v-if="submitMovCompraItem && v$.wmsOsItemData.vlrunitliq.$error"
                       class="invalid-feedback">
                    <span v-if="v$.wmsOsItemData.vlrunitliq.required.$message">{{ v$.wmsOsItemData.vlrunitliq.required.$message }}</span>
                  </div>
                </div>
              </div>


              <div class="col-md-4">
                <div class="mb-3">

                </div>
              </div>


              <div class="col-md-4">
                <div class="mb-3">
                  <label for="qtd">Quantidade</label>
                  <input
                      id="qtd"
                      v-model="wmsOsItemData.qtd"
                      type="number"
                      class="form-control text-end"
                      placeholder="Quantidade"
                      :class="{'is-invalid': submitMovCompraItem && v$.wmsOsItemData.qtd.$error,}"/>
                  <div v-if="submitMovCompraItem && v$.wmsOsItemData.qtd.$error"
                       class="invalid-feedback">
                    <span v-if="v$.wmsOsItemData.qtd.required.$message">{{ v$.wmsOsItemData.qtd.required.$message }}</span>
                  </div>
                </div>
              </div>

            </div>


            <div class="row">

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="icmsvbc">Base ICMS(R$)</label>
                  <input
                      id="icmsvbc"
                      v-model="wmsOsItemData.icmsvbc"
                      type="number"
                      class="form-control text-end"
                      placeholder="Base ICMS(R$)"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="icmsvlr">Valor ICMS(R$)</label>
                  <input
                      id="icmsvlr"
                      v-model="wmsOsItemData.icmsvlr"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor ICMS(R$)"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="icmsaliq">Alíq. ICMS(%)</label>
                  <input
                      id="icmsaliq"
                      v-model="wmsOsItemData.icmsaliq"
                      type="number"
                      class="form-control text-end"
                      placeholder="Alíq. ICMS(%)"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="ipivlr">Valor IPI (R$)</label>
                  <input
                      id="ipivlr"
                      v-model="wmsOsItemData.ipivlr"
                      type="number"
                      class="form-control text-end"
                      placeholder="Valor IPI (R$)"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-3">
                  <label for="ipialiq">Alíq. IPI(%)</label>
                  <input
                      id="ipialiq"
                      v-model="wmsOsItemData.ipialiq"
                      type="number"
                      class="form-control text-end"
                      placeholder="Alíq. IPI(%)"/>
                </div>
              </div>

<!--              <div class="col-md-2">-->
<!--                <div class="mb-3">-->
<!--                  <label for="cofinscst">CST COFINS</label>-->
<!--                  <input-->
<!--                      id="cofinscst"-->
<!--                      v-model="wmsOsItemData.cofinscst"-->
<!--                      type="text"-->
<!--                      class="form-control"-->
<!--                      placeholder="CST COFINS"/>-->
<!--                </div>-->
<!--              </div>-->

            </div>

          </form>

<!--        <div class="table-responsive mt-2">-->
<!--          <table class="table table-centered table-nowrap">-->
<!--            <thead>-->
<!--            <tr>-->
<!--              <th scope="col">Últimas Compras</th>-->
<!--              <th scope="col" class="text-end">Data</th>-->
<!--              <th scope="col" class="text-end">Valor (R$)</th>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr v-for="data in ultPedsData" :key="data.id">-->
<!--              <td>-->
<!--                <router-link :to="`/movcompra/editar/${data.id}`" target="_blank">-->
<!--                  <div>-->
<!--                    <h5 class="text-truncate font-size-14">-->
<!--                      {{ data.codigo }}-->
<!--                    </h5>-->
<!--                  </div>-->
<!--                </router-link>-->
<!--              </td>-->
<!--              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>-->
<!--              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <td colspan="2">-->
<!--                <h6 class="m-0 text-end">Maior compra com este fornecedor (2 und):</h6>-->
<!--              </td>-->
<!--              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>-->
<!--            </tr>-->

<!--            <tr>-->
<!--              <td colspan="2">-->
<!--                <h6 class="m-0 font-size-14  text-end">Desconto({{ formatDecimal(wmsOsItemData.desconto) }}%):</h6>-->
<!--              </td>-->
<!--              <td class="font-size-14 text-end">R$ {{ formatDecimal(wmsOsItemData.vlrtotalbrt - wmsOsItemData.vlrtotalliq) }}</td>-->
<!--            </tr>-->

<!--            <tr>-->
<!--              <td colspan="2">-->
<!--                <h6 class="m-0 font-size-14  text-end">Valor Total Líquido do Item:</h6>-->
<!--              </td>-->
<!--              <td class="font-size-14 text-end">R$ {{ formatDecimal(wmsOsItemData.vlrtotalliq) }}</td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--          </table>-->
<!--        </div>-->

      </div>

      <div>
        <div class="row">
          <div class="text-start mt-5">
            <router-link  to="/produto/editar/0" target="_blank">
              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
              Cadastrar Novo Produto
            </router-link>
          </div>
        </div>
      </div>

      <div v-if="!loadingMovCompraItem && wmsOsItemData && wmsOsItemData.descprod">
        <div class="row">
          <div class="text-end mt-0">
            <b-button variant="light" @click="showModalMovCompraItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confMovCompraItem">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal  size="lg"
              title="Endereçamento de Item" v-model="showModalSepara" centered hide-footer>


      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="palete">Selecionar Palete</label>

            <multiselect id="palete"
                         @search-change="pesqPalete"
                         @select="escolheuPalete"
                         v-model="wmsOsItemSepData.palete"
                         placeholder="Pesquisar palete"
                         :options="dtlistPesqPalete"
                         :searchable="true"
                         label="codigo"
                         track-by="codigo"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                    <span class="mx-4" >
                    {{ slotProps.option.endereco }}
                  </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                  <span class="mx-4" >
                  </span>
                  <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                </div>
              </template>
            </multiselect>

          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="endereco">Selecionar Endereço</label>

            <multiselect id="endereco"
                         @search-change="pesqEndereco"
                         @select="escolheuEndereco"
                         v-model="wmsOsItemSepData.endwms"
                         placeholder="Pesquisar endereços"
                         :options="dtlistPesqEndereco"
                         :searchable="true"
                         label="descricao"
                         track-by="descricao"
                         value-prop="descricao">
              <template #option="slotProps">
                <div class="row">
                  <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                    <span class="mx-4" >
                    {{ slotProps.option.endereco }}
                  </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                  <span class="mx-4" >
                  </span>
                  <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="produto">Informar/Confirmar o produto(enter ou botão)<i class="bx bx-skip-next-circle font-size-18 align-middle" @click="informouProduto" style="cursor: pointer"></i></label>
            <input
                id="produto"
                ref="produto"
                v-model="wmsOsItemSepData.produto"
                type="text"
                class="form-control"
                @keypress.enter="informouProduto"
                @blur="informouProduto"
                placeholder="Enter para confirmar..."/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="produtodesc">Produto</label>
            <input
                id="produtodesc"
                ref="produtodesc"
                v-model="wmsOsItemSepData.descprod"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Produto"/>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-4">
          <div class="mb-3">
            <label for="lote">Lote(enter ou botão) <i class="bx bx-skip-next-circle font-size-18 align-middle" @click="informouLote" style="cursor: pointer"></i></label>
            <input
                id="lote"
                ref="lote"
                v-model="wmsOsItemSepData.lote"
                type="text"
                class="form-control"
                @keypress.enter="informouLote"
                @blur="informouLote"
                placeholder="Informar lote..."/>
            <div v-if="obrigInfoLote">
              <span class="text-danger font-size-11">Lote obrigatório, favor preencher.</span>
            </div>
            <div v-else>
              <span class="text-success font-size-11">Lote opcional | não obrigatório</span>
            </div>
          </div>
        </div>


        <div class="col-md-4">
          <div class="mb-3">
            <label for="serie">Série</label>
            <input
                id="serie"
                ref="serie"
                v-model="wmsOsItemSepData.serie"
                type="text"
                placeholder="Série do lote..."
                class="form-control"/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3">
            <label for="dtvalid">Validade</label>
            <input
                id="dtvalid"
                ref="dtvalid"
                v-model="wmsOsItemSepData.dtvalid"
                type="date"
                class="form-control"
                @keypress.enter="informouDtValid"
                placeholder="Enter para confirmar..."/>
          </div>
        </div>
      </div>


      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="qtdsep">Favor informar a quantidade</label>
            <input
                id="qtdsep"
                v-model="wmsOsItemSepData.qtd"
                type="number"
                ref="qtdsep"
                class="form-control"
                @keypress.enter="informouQtd"
                placeholder="Enter para confirmar..."/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="qtdsepdisp">Quantidade Disponível</label>
            <input
                id="qtdsepdisp"
                v-model="wmsOsItemSepData.disp"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Quantidade Disponível"/>
          </div>
        </div>

      </div>

      <!--<div class="row">
        <div class="col-md-6">
          <div class="mb-3 ">
            <h5 class="font-size-14">Ocorrência</h5>
            <b-form-checkbox
                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="wmsOsItemSepData.stsocor">
              {{ wmsOsItemSepData.stsocor === 'A' ? 'Informar Ocorrência' : 'Sem Ocorrência' }}
            </b-form-checkbox>
          </div>
        </div>

        <div class="col-md-6" v-if="wmsOsItemSepData.stsocor === 'A'">
          <div class="mb-3">
            <label for="tipo">Tipo Ocorrência</label>
            <select
                id="tipoocor"
                v-model="wmsOsItemSepData.tipoocor"
                class="form-control">
              <option value="AV">Avaria</option>
              <option value="FA">Falta</option>
              <option value="SO">Sobra</option>
              <option value="OU">Outros</option>
            </select>

          </div>
        </div>
      </div>-->




      <div class="row" v-if="loadingWmsEnder">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>



      <div class="table-responsive" v-if="wmsOsItemSepDataList">
        <table class="table table-centered table-nowrap">
          <thead>
          <tr>

            <th scope="col">Separado (ID)</th>
            <th scope="col">Palete</th>
            <th scope="col">Endereço</th>
            <th scope="col">Lote</th>
            <th scope="col">Fabricação</th>
            <th scope="col">Validade</th>
            <th scope="col" class="text-end">Quantidade</th>
<!--            <th scope="col" class="text-end">Data</th>-->

          </tr>
          </thead>
          <tbody>
          <tr v-for="data in wmsOsItemSepDataList" :key="data.id">
            <td>
              <div>
                <h5 class="text-truncate font-size-14">
                  {{ data.id }}
                </h5>
              </div>
            </td>
            <td class="">{{ data.palete }}</td>
            <td class="">{{ data.endwms }}</td>
            <td class="">{{ data.lote }}</td>
            <td class="">{{ formatDate(data.dtfabric) }}</td>
            <td class="">{{ formatDate(data.dtvalid) }}</td>
            <td class="text-end">{{ formatDecimal(data.qtd) }}</td>
<!--            <td class="text-end">{{ formatDateTime(data.created_at) }}</td>-->
          </tr>
          </tbody>
        </table>
      </div>


      <div v-if="!loadingWmsEnder">

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalSepara = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1"
                    :disabled="!wmsOsItemSepData.descprod || !wmsOsItemSepData.qtd || !wmsOsItemSepData.disp || wmsOsItemSepData.disp <= 0 || wmsOsItemSepData.qtd === 0 || wmsOsItemSepData.qtd > wmsOsItemSepData.disp || !wmsOsItemSepData.palete"
                    @click="confirmarSeparacao">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>



    </b-modal>

    <b-modal size="lg" title="Endereçamento de Item (Todos)" v-model="showModalSeparaTodos" centered hide-footer>

      <div class="mb-4">
        <span>Ao efetivar o recebimento em massa, os produtos serão alocados no seguinte endereço. </span>
      </div>

      <div class="row">
        <div class="col-md-2">
          <div class="mb-3">
            <label for="palete">Palete</label>
            <input
                id="palete"
                v-model="sepTodos.palete"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="endereco">Endereço</label>
            <input
                id="endereco"
                v-model="sepTodos.descricao"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3 ">
            <label for="tipo">Tipo Endereço</label>
            <input
                id="tipo"
                v-model="sepTodos.tipo"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>
        <!--        <div class="col-md-2">
          <div class="mb-3 ">
            <label for="posx">Posição X</label>
            <input
                id="posx"
                v-model="sepTodos.posx"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3 ">
            <label for="posy">Posição Y</label>
            <input
                id="posy"
                v-model="sepTodos.posy"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>-->
      </div>

        <!--      <div class="row">
        <div class="col-md-4">
          <div class="mb-3 ">
            <label for="compr">Comprimento</label>
            <input
                id="compr"
                v-model="sepTodos.compr"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3 ">
            <label for="larg">Largura</label>
            <input
                id="larg"
                v-model="sepTodos.larg"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3 ">
            <label for="alt">Altura</label>
            <input
                id="alt"
                v-model="sepTodos.alt"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>
      </div>-->

      <div v-if="!loadingWmsEnder">
        <div class="text-end mt-5">
          <b-button variant="outline-danger" @click="showModalSepara = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1"
                    @click="validaFinalizacao('todos')">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal size="lg" title="Endereçamento de Item (Todos)" v-model="showModalSeparaTodos2" centered hide-footer>

      <div class="mb-4">
        <span>Ao efetivar o recebimento em massa, os produtos serão alocados no seguinte endereço. </span>
      </div>

      <div class="row">
        <!--<div class="col-md-2">
          <div class="mb-3">
            <label for="palete">Palete</label>
            <input
                id="palete"
                v-model="sepTodos.palete"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>-->

        <div class="col-md-6">
          <div class="mb-3">
            <label for="novoendwms">Novo Endereço</label>

            <multiselect id="novoendwms"
                         @search-change="pesqEndereco"
                         v-model="sepTodos.descricao"
                         placeholder="Pesquisar endereços"
                         :options="dtlistPesqEndereco"
                         :searchable="true"
                         label="descricao"
                         ref="novoendwms"
                         track-by="descricao"
                         value-prop="descricao">
              <template #option="slotProps">
                <div class="row">
                  <div>
                        <span class="text-info">
                          {{ slotProps.option.codigo }}
                        </span>
                    <span class="mx-4" >
                          {{ slotProps.option.endereco }}
                        </span>
                  </div>
                  <div class="mt-2 ">{{ slotProps.option.descricao }}</div>
                  <span class="mx-4" >
                        </span>
                  <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3 ">
            <label for="tipo">Tipo Endereço</label>
            <input
                id="tipo"
                v-model="sepTodos.tipo"
                type="text"
                class="form-control"
                disabled/>
          </div>
        </div>
      </div>

      <div v-if="!loadingWmsEnder">
        <div class="text-end mt-5">
          <b-button variant="outline-danger" @click="showModalSeparaTodos2 = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1"
                    @click="validaFinalizacao('todos')">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>


    <b-modal id="showModalRelatTFA" title="Relatório de TFA" v-model="showModalRelatTFA" centered hide-footer>
      <div class="col-md-12">

        <div class="table-responsive">
          <table class="table align-middle mb-0">
            <thead class="table-light">
            <tr>
              <th>ID Item</th>
              <th>Qtd. Disp.</th>
              <th>Qtd. Lida</th>
              <th>Qtd. Falta</th>
              <!--                    <th>Ocorrencia</th>-->
              <!--                    <th>Dt. TFA</th>-->
            </tr>
            </thead>
            <tbody>
            <template v-for="(data, index) in dtListRelatTFA" :key="data.idItem">
              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                <td class="text-start">{{data.iditem}}</td>
                <td class="text-start">{{data.qtddisp}}</td>
                <td class="text-start">{{data.qtdlida}}</td>
                <td class="text-start">{{data.qtdfalta}}</td>
                <!--                      <td class="text-center">{{data.message}}</td>-->
                <!--                      <td class="text-start">{{ formatDate(data.data) }}</td>-->
              </tr>
              <tr :style="{ backgroundColor: index % 2 === 0 ? '#ffffff ' : '#dae9fa' }">
                <td colspan="4" class="text-muted small ps-3" style="border-top: none;padding-top: 2px; padding-bottom: 2px; line-height: 1.2;">
                  {{ data.data ? formatDate(data.data) + ' - ' + data.message : data.message}}
                </td>
              </tr>
            </template>
            </tbody>
          </table>

          <div class="mt-2 p-2">
            <span class="text-danger">
              Deseja prosseguir com a confirmação da separação dos itens mesmo assim?
            </span>
          </div>

          <div class="text-end mt-3">
            <b-button variant="light" @click="showModalRelatTFA = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                @click="confFinalizarParcialColetor"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>



<style>
.multiselect-size {
  --ms-max-height: 500px;
}
</style>

